module.exports = __webpack_public_path__ + "static/media/217.9150e37b.mp3";